export default "<ion-app>\n  <div class=\"app-version\">v{{ version }}</div>\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n";